import language from "#scripts/translation";

export const campaigns = (obj) => {
    return `
        <section id="module__campaigns_${obj.moduleID}" class="module__campaigns ${obj.campaignDesign} p-md-0 justify-content-md-center">
            <div class="container p-0">
                <div class="campaign ${obj.maxItems === 1 ? "single" : ""}" id="campaigns_${obj.moduleID}"></div>
            </div>
        </section>`;
};

export const campaignItem = (obj) => {
    return `
        <a class="campaign__item" ${obj.link.substring(0, 4) === "http" ? `href="${obj.link}" aria-label="${obj.forsidetittel} (${language("NAV_OPEN_I_NEW")})" target="_blank"` : `href="${obj.link}"`
        } ${obj.color !== "" ? `style="background-color:${obj.color};"` : ""}>
            ${obj.image}
            <div class="campaign__content">
                <span class="campaign__title">${obj.forsidetittel}${obj.link.substring(0, 4) === "http" ? ` <span class="material-icons-outlined notranslate campaign__title__icon-external_link">&#xE89E;</span>` : ""
        }</span>
                <p class="campaign__text">${obj.forsidetekst}</p>
            </div>
        </a>
    `;
};
export default campaigns;
